import React from 'react';
import FormModel from "../../../../../../gd-form/common/form-model-manager";
import UserAssignment from "../../../../model/user-assignment";
import Form from "../../../../../../gd-form/form/form-ui5/form";
import ReassignUserTasks from "../../../../project-user-edit/components/reassign-items/tasks";
import ReassignUserEvents from "../../../../project-user-edit/components/reassign-items/events";
import ReassignUserProjects from "../../../../project-user-edit/components/reassign-items/projects";
import FormsCallbackManager from "../../../manager/forms-callback-manager";
import UserIcon from "../../../../../../gd-components/icons/user/user";
import User from "../../../../../../model2/user/user";

type Props = {
    user                    : User | null
    model                   : UserAssignment
    userOptions             : Options
    formsCallbackManager    : FormsCallbackManager
}

export default class UserReassignForm extends React.Component<Props>{

    public form: FormModel

    constructor(props: Props) {
        super(props);

        this.form = new FormModel(props.model, {
            onSubmit: this.onSubmit
        });

        this.props.formsCallbackManager.addCallback(this.triggerOnSubmit)
    }

    triggerOnSubmit = ()=> {
        this.form.onSubmitClick.call(this.form)

        if (!this.form.isFormValid) {
            this.props.formsCallbackManager.isFormsValid = this.form.isFormValid
        }
    }

    onSubmit = (data: UserAssignment)=> {
        this.props.formsCallbackManager.submitData.add(data)
    }

    render() {

        return (
            <>
                <div className="flex-row-left-center m-t-25">
                    <UserIcon className="m-r-10" size="26" userId={this.props.model.id}/>
                    <div className="ui5-title-small">{this.props.user?.name}</div>
                </div>
                <div className="p-l-10 p-r-35 m-l-1">
                    <Form>
                        <ReassignUserTasks form         = {this.form}
                                           tasks        = {this.props.model.tasks}
                                           userOptions  = {this.props.userOptions}/>
                        <ReassignUserEvents form        = {this.form}
                                            events      = {this.props.model.events}
                                            userOptions = {this.props.userOptions}/>
                        <ReassignUserProjects form          = {this.form}
                                              projects      = {this.props.model.projects}
                                              userOptions   = {this.props.userOptions}/>
                    </Form>
                </div>
            </>
        );
    }
}
